<template>
    <el-col :xs="{span:24}" :md="width" v-show="show">
        <el-form-item 
            :class="className"
            :label="displayName" 
            :prop="name"
            :rules="rules">
            <textarea :name="fieldName" :value="data[name]" hidden="hidden"> </textarea>
            <el-input type="textarea"
                :autosize="{ minRows: 4 }"
                v-model.lazy="data[name]"
                :show-word-limit = "showWordLimit"
                :minlength = "minLength"
                :maxlength = "maxLength"
                :disabled="disabled">
            </el-input>
            <div class="hint"><i>{{ hint }}</i></div>
        </el-form-item>
    </el-col>
</template>

<script>
    import baseTextField from "../TextField/BaseTextField"

    export default {
        name:"MultTextField",
        mixins:[baseTextField],
        methods:{
            subSetRules:function(){
                
            }
        }
    }
</script>